import WorkImg1 from 'assets/images/step-1.7975394a.jpg';
import WorkImg2 from 'assets/images/step-2.0d5ff727.jpg';
import WorkImg3 from 'assets/images/step-3.070bae01.jpg';
import WorkImg4 from 'assets/images/step-4.d6316948.jpg';
import arrow1 from 'assets/images/arrow-1.e50b7ddf.png';
import arrow2 from 'assets/images/arrow-2.7a8b4722.png';
import arrow3 from 'assets/images/arrow-3.efc3debf.png';

export const homeWork = [
	{
		img: WorkImg1,
		arrow: arrow1,
		step: '1',
		desc: 'STEP',
		title: 'Giao hàng tận nơi',
		info: 'Choose Your Favorite',
	},

	{
		img: WorkImg2,
		arrow: arrow2,
		step: '2',
		desc: 'STEP',
		title: 'Giao hàng tận nơi',
		info: 'We Deliver Your Meals',
	},

	{
		img: WorkImg3,
		arrow: arrow3,
		step: '3',
		desc: 'STEP',
		title: 'Giao hàng tận nơi',
		info: 'Cash on Delivery',
	},

	{
		img: WorkImg4,
		step: '4',
		desc: 'STEP',
		title: 'Giao hàng tận nơi',
		info: 'Eat And Enjoy',
	},
];
